import Http from '../libs/http';

export default {

  // 订单价格检测
  orderPriceDetect(orderId, couponId, rejectProduct) {
    return Http.post('/order_price_detect', {
      user_order_id: orderId,
      // first_order: firstOrder,
      peer_coupon_id: couponId || undefined,
      reject_product_set: rejectProduct,
    });
  },

  // 顺丰上门取资料提交
  pickUpSubmit(params) {
    return Http.post('/pickup_submit', params);
  },

  // 拉取地址
  peerAddressBriefQuery() {
    return Http.post('/peer_address_total_query', {});
  },

  // 订单刷新
  orderRefresh(id) {
    return Http.post('/order_refresh', { user_order_id: id });
  },

  // 同业查询
  peerQuery() {
    return Http.post('/visa_peer_query');
  },

  // 格式放假日期
  formatHoliday(holidays, disabledDate) {
    const result = [];
    holidays.forEach((ele) => {
      if (new Date(ele).getDay() === 0 || new Date(ele).getDay() === 6) {
        if (
          new Date(ele).getTime() <= new Date(disabledDate).getTime()
            && new Date(ele).getTime() >= new Date().getTime()
        ) {
          result.push({ date: ele, dayText: '休' });
        }
      } else {
        if (
          new Date(ele).getTime() <= new Date(disabledDate).getTime()
            && new Date(ele).getTime() >= new Date().getTime()
        ) {
          result.push({ date: ele, dayText: '假' });
        }
      }
    });
    return result;
  },
};



// WEBPACK FOOTER //
// ./src/services/order-comfirm-service.js